const initialState = {
    get: [], 
    remove:[],
    
  
  };
  
  const DODoctorReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_GET_SUCCESS':
            return {... state, get:action.payload};
            case 'FETCH_REMOVE_SUCCESS':
            return {... state, remove:action.payload};
            
            
      default:
        return state;
    }
  };
  
  export default DODoctorReducers;
  
  